import { formatAmount } from "../../formatAmount.js";
import { HETZNER_AMOUNT, HETZNER_REVERSE_VAT } from "../../hetzner.js";
import { Template } from "../../template/Template.js";
import { prefillTemplate } from "../../template/prefillTemplate.js";
import { INCOMING_EU_INVOICE } from "./IncomingEuInvoice.js";

export const HETZNER_INVOICE: Template = prefillTemplate(
  INCOMING_EU_INVOICE,
  "0ed5534c-9a8c-49c9-9f26-9bc664821f35",
  "Hetzneri arve (server)",
  [
    {
      name: "Title",
      value: "Hetzneri arve"
    }
  ],
  [
    {
      name: "Expense amount",
      value: formatAmount(HETZNER_AMOUNT)
    },
    {
      name: "Reverse VAT",
      value: formatAmount(HETZNER_REVERSE_VAT)
    }
  ]
);
